import { createContext } from "react";

import { Subscription } from "@/types/subscription";

export interface SubscriptionContextType {
  subscriptions: Subscription[];
  hasEverSubscribed: boolean;
  isLoading: boolean;
  error: string | null;
  refetchSubscriptions: () => Promise<void>;
  findSubscriptionBySlug: (slug: string) => Subscription | undefined;
  isSubscribedToTreatment: (slug: string) => boolean;
  portalLink: string;
  isPortalLinkLoading: boolean;
  portalLinkError: string | null;
}

export const SubscriptionContext = createContext<SubscriptionContextType>({
  subscriptions: [],
  hasEverSubscribed: false,
  isLoading: true,
  error: null,
  refetchSubscriptions: async () => {},
  findSubscriptionBySlug: () => undefined,
  isSubscribedToTreatment: () => false,
  portalLink: "",
  isPortalLinkLoading: false,
  portalLinkError: null,
});
